import React from "react";
import TwoFAInputs from "./TwoFAInputs";

const TwoFAForm = ({ code, onCodeChange, inputsRef, loading, cooldown, onResend, onSubmit, onBack }) => {
  return (
    <>
      {onBack && (
        <button
          type="button"
          className="backButtonForgotPassword"
          onClick={onBack}
          style={{ marginBottom: "10px", padding: "5px 10px", fontSize: "12px" }}
        >
          ← Retour
        </button>
      )}
      <h1 className="title2fa">Code d'authentification</h1>
      <TwoFAInputs code={code} onCodeChange={onCodeChange} inputsRef={inputsRef} />
      <span>Saisissez le code reçu sur votre adresse mail</span>
      <button
        type="button"
        className="btnResend2FACode"
        onClick={onResend}
        disabled={cooldown > 0}
      >
        Envoyer à nouveau
        {cooldown > 0 && (
          <>
            <br />
            <span className="cooldownText">Disponible dans : {cooldown}s</span>
          </>
        )}
      </button>
      <button type="button" className="buttonStart2faAuth" onClick={onSubmit} disabled={loading}>
        {loading ? "..." : "Continuer"}
      </button>
    </>
  );
};

export default TwoFAForm;
